import { ReviewFormsList } from "@/components/reviews/ReviewFormsList";
import { useSetBreadcrumbs } from "@/components/shared/breadcrumbs";
import { PageHeader } from "@/components/shared/page-header";

/**
 * Feedback → Reviews → Review forms.
 *
 * Kept flat in `src/routes/dashboard/` rather than nested under a `reviews/`
 * folder: nesting a page file deeper makes knip stop seeing its import and fail
 * the pre-commit hook, the same trap the Settings → Logs pages documented. The
 * URL is nested; the file is not.
 */
export function ReviewFormsPage() {
  useSetBreadcrumbs([
    { label: "Feedback" },
    { label: "Reviews", to: "/dashboard/reviews" },
    { label: "Review Forms" },
  ]);

  return (
    <div className="space-y-6">
      <PageHeader
        title="Review Forms"
        description="What each review asks, who it applies to, and who is asked to fill it in."
      />
      <ReviewFormsList />
    </div>
  );
}
